/**
 * Central mapping of notification `kind` → { icon, tone, linkFor }.
 * Used by both the bell dropdown and the /notifications full page so
 * the two views stay in sync visually and by click-through behaviour.
 */
import {
  CheckSquare, MessageSquare, AtSign, BookOpen, PlaySquare, Award,
  Megaphone, Bell, MessageCircle, FileClock, ClipboardCheck, Library, ShieldCheck, AlertTriangle, Gauge, CalendarClock,
} from "lucide-react";


export const NOTIFICATION_KINDS = {
  task_assigned: {
    icon: CheckSquare, tone: "text-blue-700",
    linkFor: () => "/tasks",
  },
  task_commented: {
    icon: MessageSquare, tone: "text-blue-700",
    linkFor: () => "/tasks",
  },
  task_mention: {
    icon: AtSign, tone: "text-purple-700",
    linkFor: () => "/tasks",
  },
  procedure_published: {
    icon: BookOpen, tone: "text-emerald-700",
    linkFor: (n) => n.procedure_id ? `/procedures/${n.procedure_id}` : "/learning?tab=procedures",
  },
  training_assigned: {
    icon: PlaySquare, tone: "text-indigo-700",
    linkFor: (n) => n.training_module_id ? `/learning/training/${n.training_module_id}` : "/learning?tab=training",
  },
  training_module_published: {
    icon: PlaySquare, tone: "text-emerald-700",
    linkFor: (n) => n.training_module_id ? `/learning/training/${n.training_module_id}` : "/learning?tab=training",
  },
  qualification_expiry: {
    icon: Award, tone: "text-red-700",
    linkFor: () => "/learning?tab=qualifications",
  },
  announcement_published: {
    icon: Megaphone, tone: "text-purple-700",
    linkFor: () => "/learning?tab=announcements",
  },
  enquiry_follow_up_due: {
    icon: CalendarClock, tone: "text-amber-700",
    linkFor: (n) => n.enquiry_id ? `/enquiries?open=${n.enquiry_id}` : "/enquiries?view=follow_ups",
  },
  enquiry_assigned: {
    icon: MessageCircle, tone: "text-blue-700",
    linkFor: (n) => n.enquiry_id ? `/enquiries?open=${n.enquiry_id}` : "/enquiries?view=mine_open",
  },
  assessment_onboarding_changed: {
    icon: FileClock, tone: "text-amber-700",
    linkFor: (n) => n.assessment_id ? `/assessments/${n.assessment_id}` : "/notifications",
  },
  checkin_alert: {
    icon: ClipboardCheck, tone: "text-red-700",
    linkFor: (n) => n.alert_id ? `/progress-review?alert=${n.alert_id}` : "/progress-review",
  },
  resource_review_requested: {
    icon: ShieldCheck, tone: "text-amber-700",
    linkFor: (n) => n.resource_id ? `/resource-library/${n.resource_id}` : "/resource-library",
  },
  resource_decision: {
    icon: Library, tone: "text-emerald-700",
    linkFor: (n) => n.resource_id ? `/resource-library/${n.resource_id}` : "/resource-library",
  },
  resource_review_overdue: {
    icon: AlertTriangle, tone: "text-red-700",
    linkFor: (n) => n.resource_id ? `/resource-library/${n.resource_id}` : "/resource-library",
  },
  kpi_draft_ready: {
    icon: Gauge, tone: "text-blue-700",
    linkFor: (n) => n.week ? `/kpi?week=${n.week}` : "/kpi",
  },
  kpi_sync_failed: {
    icon: AlertTriangle, tone: "text-red-700",
    linkFor: () => "/kpi?tab=inputs",
  },
  default: {
    icon: Bell, tone: "text-zinc-500",
    linkFor: () => "/notifications",
  },
};
